module.exports = "<div class=\"electricBoogaloo\" id=\"displayMessage\" *ngIf=\"display\">\n  <h3>Item added to your cart!</h3>\n  <button (click)=\"handleContinue()\" class=\"btn btn-warning\">Continue Shopping</button>\n  <button (click)=\"handleCart()\" class=\"btn btn-info\">My Cart</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/functional_components/product-detail/more-shopping-buttons/more-shopping-buttons.component.html
// module id = 404
// module chunks = 1